export default __webpack_public_path__ + "static/illustration-denmark.url-9183a7eafe7d2aadcf4563cd4ba20121.svg";